import { css } from 'lit'

export const futureDeliveriesStyle = css`
  .future-date {
    display: inline-block;
  }
`
